import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface UserUiSettingsModel {
  app: string;
  hiddenTabs: string[];
}

export interface SaveHiddenTabsRequest {
  app: string;
  hiddenTabs: string[];
}

@Injectable({
  providedIn: 'root'
})
export class HxUserUiSettingsService {

  constructor(
    private http: HttpClient,
  ) {
  }

  getHiddenTabs(app: string): Promise<UserUiSettingsModel> {
    return firstValueFrom(
      this.http.get<UserUiSettingsModel>(`/api/vn/user-ui-settings/hidden-tabs`, {
        params: {app}
      })
    );
  }

  saveHiddenTabs(request: SaveHiddenTabsRequest): Promise<UserUiSettingsModel> {
    return firstValueFrom(
      this.http.put<UserUiSettingsModel>(`/api/vn/user-ui-settings/hidden-tabs`, request)
    );
  }
}
